export * from './MenuHeaderDetailsStoreHoursText';
